import React, {useContext, useEffect, useState } from "react";
import { Button, Grid, Box, Modal,Backdrop, CircularProgress,LinearProgress, TextareaAutosize , FormLabel } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { FormProvider, useForm } from "react-hook-form";
import DnerhsApi from "../../api/DnerhsApi";
import FormInput from "../../Controls/Input";
import FormSelect from "../../Controls/Select";
import Alert from "../../components/Alert";
import ResponseUtils from "../../utils/ResponseUtils";
import history from "../../utils/History";
import { useParams, useLocation } from "react-router-dom";
import useAuth from "../../hooks/Auth";
import Roles from "../../constants/Roles";
import { getCarrerasProgramas } from "services/ConvenioService";
import { findByNumeroCedula } from "services/DatosPersonalesService";
import { trackPromise } from "react-promise-tracker";
import Checkbox from '@material-ui/core/Checkbox';
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers";
import UserContext from "../../context/User/UserContext";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import FormCheckBox from "../../Controls/Checkbox";
import FormDatePicker from "../../Controls/DatePicker";
import axios from "axios";
import DeleteDialog from "../../dialogs/DeleteDialog";

const useStyles = makeStyles((theme) => ({
  main: {
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
  },
  form: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  field: {
    margin: theme.spacing(),
  },
}));
const validationSchema = yup.object().shape({
  nombre: yup.string().required("El campo nombres es requerido"),
  apellido: yup.string().required("El campo apellidos es requerido"),
  cedulaIdentidad: yup.string().required("El campo cedula de identidad es requerido"),
  email: yup.string().email("Ingrese un email válido").required("El campo email es requerido"),
  numeroRegistroProfesional: yup.string().required("El campo Registro Profesional es requerido"),
  fechaVigencia: yup.string().required("El campo fecha de vigncia es requerido")

});

const DIAS_SEMANA2 = [
  {
    id: 1,
    label: "lunes",
  },
  {
    id: 2,
    label: "martes",
  },
  {
    id: 3,
    label: "miercoles",
  },
  {
    id: 4,
    label: "jueves",
  },
  {
    id: 5,
    label: "viernes",
  },
  {
    id: 6,
    label: "sabado",
  },
  {
    id: 7,
    label: "domingo",
  }
];

const Form = () => {
  const classes = useStyles();
  const [carreraOptions, setCarreraOptions] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isUpdateCreate, setIsUpdateCreate] = useState(false);
  
  const [profesional, setProfesional] = useState({});

  const [tutoresResponseData, setTutoresResponseData] = useState({});
  const params = useParams();
  const methods = useForm({ resolver: yupResolver(validationSchema) });
  const { handleSubmit, errors, setValue, reset } = methods;
  const [isReadOnly, setIsReadOnly] = useState(false);
  const { hasRole } = useAuth();
  let { state } = useLocation();
  const [idTutor, setIdTutor] = useState();
  const [fechaCreacion, setFechaCreacion] = useState();
  const [usuarioCreacion, setUsuarioCreacion] = useState();
  const { userData } = useContext(UserContext);
  const isAdmin = userData && userData.role.descripcion === "ROLE_ADMIN";
  const methods2 = useForm({
    shouldUnregister: false,
    //  resolver: yupResolver(validationSchema),
  });
  const [isCargarHorario, setIsCargarHorario] = useState(false);

  const {  handleSubmit: handleSubmit2,   errors: errors2,  reset: reset2, setValue: setValues2,  getValues: getValues2 } = methods2;
  const [timeDesde, setTimeDesde] = useState("00:00");
  const [timeHasta, setTimeHasta] = useState("00:00");
  const [horarios, setHorarios] = useState([]);
  const [profesionalId, setProfesionalId] = useState();
  const [profesion, setProfesion] = useState();
  const [esTutor, setEsTutor] = useState(false);  
  const [esExterno, setEsExterno] = useState(false);
  const [isNotReg, setIsNotReg] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [toDelete, setToDelete] = useState();
  const [indexx, setIndex] = useState();
  const [estabecimientoProfesion, setEstabecimientoProfesion] = useState();
  const [nombreServicio, setNombreServicio] = useState();
  const [deshabilitaRegistroVigencia, setDeshabilitaRegistroVigencia] = useState(false);
  useEffect(() => {
    const load = () => {
      try {
        if (state?.edit || state?.readOnly) {
          setIsUpdate(state?.edit);
          setIsReadOnly(state?.readOnly);
          setIsCargarHorario(false);
          setValuesForEdit();
        }
        setProfesion(params.profesion);

      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, []);
  const changeTimeDesde = (e) => {
    setTimeDesde(e.target.value)
  }
  const changeTimeHasta = (e) => {
    setTimeHasta(e.target.value)
  }


  const loadCarreraOptions = (carreras) => {
    setCarreraOptions(
      carreras.map((carrera) => ({
        label: carrera.carreraPrograma.descripcion,
        id: carrera.carreraPrograma.id,
      }))
    );
  }
  const handleOpenDialog = (id, index) => {
    setOpenDialog(true);
    setToDelete(id);
    setIndex(index);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const deleteOne = async () => {
    try {
      let message = ""; 
      let url = `/profesionales-horarios/${toDelete}`;
      const response = await DnerhsApi.delete(url);
      console.log("response delete", response);
      message = `Registro con id ${toDelete} eliminado correctamente`;
      Alert.show({
        message,
        type: "success"
      });
    } catch (error) {
      console.log(error);
    }
    setOpenDialog(false);
    setToDelete();
    let listCopy = [...horarios];
    listCopy.splice(indexx, 1);
    setHorarios(listCopy);
  };
  const setValuesForEdit = async () => {
    try {
      setIsCargarHorario(true);

      let { convenioTutorId } = params;

      const { data: tutoresResponseData } = await DnerhsApi.get(`/establecimientos-profesiones-profesionales/${params.establecimientoProfesionIdProfesionalId}`);

      setTutoresResponseData(tutoresResponseData);
      setFechaCreacion(tutoresResponseData.tutor.fechaCreacion);
      setUsuarioCreacion(tutoresResponseData.tutor.idUsuarioCreacion)
      setIdTutor(tutoresResponseData.tutor.id)
      setProfesionalId(tutoresResponseData.profesional.id);

      /*const { data: responseCarreraProgramaData } = await DnerhsApi.get(`/convenios/${tutoresResponseData?.convenio.id}/carreras-programas`, {
        params: { pageSize: 100 },
      });*/

      let { tutor } = tutoresResponseData;

      const formValues = {
        cedulaIdentidad: tutoresResponseData.profesional.cedulaIdentidad,
        apellido: tutoresResponseData.profesional.apellidos,
        nombre: tutoresResponseData.profesional.nombres,
        email: tutoresResponseData.profesional.email,
        numeroRegistroProfesional: tutoresResponseData.profesional.numeroRegistroProfesionalVigente,
        fechaVigencia: tutoresResponseData.profesional.fechaVigencia,

        tutor: tutoresResponseData.tutor,
        externo: tutoresResponseData.externo
      };
      setEsTutor( tutoresResponseData.tutor);
      setEsExterno(tutoresResponseData.externo);
      Object.keys(formValues).forEach((field) => setValue(field, formValues[field]));
      const { data: profHorarioResponseData } = await DnerhsApi.get(`/profesionales-horarios/${tutoresResponseData.profesional.id}/profesional`);
      setHorarios(profHorarioResponseData);
      //loadCarreraOptions(responseCarreraProgramaData);
      const { data: estabProfesionResponseData } = await DnerhsApi.get(`/establecimientos-profesiones/${tutoresResponseData.establecimientoProfesion.id}`);
      setEstabecimientoProfesion(estabProfesionResponseData.profesion.id);
      setNombreServicio(estabProfesionResponseData.nombreServicio.id);
    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      } else {
        showMessageError(error);
      }
    }
  }
  const converToLocalTime = (str)  => {
    var date = new Date(str),
     mnth = ("0" + (date.getMonth() + 1)).slice(-2),
     day = ("0" + date.getDate()).slice(-2);
     console.log(new Date(new Date([date.getFullYear(), mnth, day].join("-")).toString().split('GMT')[0]+' UTC').toISOString());
      return (new Date(new Date([date.getFullYear(), mnth, day].join("-")).toString().split('GMT')[0]+' UTC').toISOString());
   }
  const onSubmit = async (data) => {
    let url = "/profesional";
    let urlEst = "/establecimientos-profesiones-profesionales";

    const dataForm = {
      cedulaIdentidad: data.cedulaIdentidad,
      apellidos: data.apellido,
      nombres: data.nombre,
      email: data.email,
      numeroRegistroProfesionalVigente: data.numeroRegistroProfesional      
    };
    const estDataForm = {
      establecimientoProfesion: {id: params.establecimientoProfesionId},
      tutor: data.tutor,
      externo: data.externo
    };
    try {
      let message = "";
      if (isUpdate) {
        let payloadUpt = { ...dataForm };
        payloadUpt.id = tutoresResponseData.profesional.id;
        payloadUpt.fechaCreacion= tutoresResponseData.profesional.fechaCreacion;
        payloadUpt.idUsuarioCreacion=tutoresResponseData.profesional.idUsuarioCreacion;
        payloadUpt.fechaVigencia=data.fechaVigencia;
        payloadUpt.webService=tutoresResponseData.profesional.webService;
        payloadUpt.habilitado= tutoresResponseData.profesional.habilitado;
       /* if(!isNotReg){
          payloadUpt.webService=false;
        payloadUpt.habilitado= false;
        let newMessage="Pendiente de aprobación por DNERHS";
        Alert.show({
          newMessage,
          type: "warning"
        });
        }else{
          payloadUpt.webService=true;
        payloadUpt.habilitado= true;
        }*/
        
        await trackPromise(DnerhsApi.put(url, {
          ...payloadUpt,
        }));
        message = "Datos guardados exitosamente.";
        let payloadEst = { ...estDataForm };
        payloadEst.id = tutoresResponseData.id;
        payloadEst.fechaCreacion= tutoresResponseData.fechaCreacion;
        payloadEst.idUsuarioCreacion=tutoresResponseData.idUsuarioCreacion;
        payloadEst.profesional= {id:tutoresResponseData.profesional.id };
        payloadEst.establecimientoProfesion= {id:tutoresResponseData.establecimientoProfesion.id };
        const result2= await trackPromise(DnerhsApi.put(urlEst, {
          ...payloadEst,
        }));
        Alert.show({
          message,
          type: "success"
        })
       setIsNotReg(true);
       const { data: profHorarioResponseData } = await DnerhsApi.get(`/profesionales-horarios/${tutoresResponseData.profesional.id}/profesional`);
       setHorarios(profHorarioResponseData);
       const { data: estabProfesionResponse } = await DnerhsApi.get(`/establecimientos-profesiones/${result2.establecimientoProfesion.id}`);

       setEstabecimientoProfesion(estabProfesionResponse.profesion.id);
       setNombreServicio(estabProfesionResponse.nombreServicio.id);
      } else if(isUpdateCreate) {
        let payloadUpt = { ...dataForm };
        payloadUpt.id = profesionalId;
        payloadUpt.fechaCreacion= profesional.fechaCreacion;
        payloadUpt.idUsuarioCreacion=profesional.idUsuarioCreacion;
        payloadUpt.fechaVigencia=data.fechaVigencia;
        payloadUpt.webService=profesional.webService;
        payloadUpt.habilitado=profesional.habilitado;
        /*if(!isNotReg){
          payloadUpt.webService=false;
        payloadUpt.habilitado= false;
        let newMessage="Pendiente de aprobación por DNERHS";
        Alert.show({
          newMessage,
          type: "warning"
        });
        }else{
          payloadUpt.webService=true;
        payloadUpt.habilitado= true;
        }*/
        
        const result= await trackPromise(DnerhsApi.put(url, {
          ...payloadUpt,
        }));
        message = "Datos guardados exitosamente.";
        estDataForm.profesional= {id:result.data.id };

        const result3= await trackPromise(DnerhsApi.post(urlEst, {
          ...estDataForm,
        }));
        Alert.show({
          message,
          type: "success"
        });
        setIsCargarHorario(true);
        setIsNotReg(true);
        const { data: profHorarioResponseData } = await DnerhsApi.get(`/profesionales-horarios/${result.data.id}/profesional`);
        setHorarios(profHorarioResponseData);
        const { data: estabProfesionResp } = await DnerhsApi.get(`/establecimientos-profesiones/${result3.data.establecimientoProfesion.id}`);

        setEstabecimientoProfesion(estabProfesionResp.profesion.id);
        setNombreServicio(estabProfesionResp.nombreServicio.id);
      }else {

        /*let payloadNew = {
          convenio: {
            id: params.convenioId,
          },
          tutor: tutorDataForm,
          carrera: { id: data.carrera },
          materia: data.materia,
          curso: data.curso
        }*/

        let payloadCreate = { ...dataForm };
        payloadCreate.fechaVigencia=converToLocalTime(data.fechaVigencia.toString());
        if(!deshabilitaRegistroVigencia){
          payloadCreate.webService=false;
          payloadCreate.habilitado= false;
          
        }else{
          payloadCreate.webService=true;
          payloadCreate.habilitado= true;
        }
        
        const result= await trackPromise(DnerhsApi.post(url, {
          ...payloadCreate,
        }));
        setProfesionalId(result.data.id);
        message = "Datos actualizados exitosamente.";
        estDataForm.profesional= {id:result.data.id };

        const result4= await trackPromise(DnerhsApi.post(urlEst, {
          ...estDataForm,
        }));
        Alert.show({
          message,
          type: "success"
        });
        if(!deshabilitaRegistroVigencia){
          Alert.show({
            message : "Pendiente de aprobación por DNERHS",
            type : "warning"
          });
        }
        setIsCargarHorario(true);
        setIsNotReg(true);
        const { data: profHorarioResponseData } = await DnerhsApi.get(`/profesionales-horarios/${result.data.id}/profesional`);
       setHorarios(profHorarioResponseData);
       const { data: estableciPRofesion } = await DnerhsApi.get(`/establecimientos-profesiones/${result4.data.establecimientoProfesion.id}`);
       setEstabecimientoProfesion(estableciPRofesion.profesion.id);
       setNombreServicio(estableciPRofesion.nombreServicio.id);
      }
      


      //history.goBack();
    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      } else {
        showMessageError(error);
      }
    }
  }
  const verificar = async (cedula) => {    
    const datainstance = axios.create({
      baseURL: `http://sirepro.mspbs.gov.py/webservices/getEstadoRegistro2.php?cedula=${cedula}`,
      timeout: 60000,
      headers: { "Content-Type": "application/json" },
    });
    const {data } = await trackPromise(datainstance.get( ));
    if (data.length>0) {
      setValue("numeroRegistroProfesional", data?.[0].nroregis);
    }else{
      setValue("numeroRegistroProfesional", "");
    }

  };
  const handleFindDatosTutor = async (event) => {
    let { target } = event;
    /*const datainstance = axios.create({
      baseURL: `http://sirepro.mspbs.gov.py/webservices/getEstadoRegistro2.php?cedula=${target.value}`,
      timeout: 20000,
      headers: { "Content-Type": "application/json" },
    });
    const {data: dataReg } = await trackPromise(datainstance.get( ));*/

    const {data: dataReg } = await trackPromise(DnerhsApi.get(`/datos-registro-profesional/${target.value}`));

    if (dataReg.nroregis) {
      setValue("numeroRegistroProfesional", dataReg?.nroregis);
      //let fechaNac=dataReg?.[0].fecha_vigencia!="" ?  dataReg?.[0].fecha_vigencia.split('-') : "";
      setValue("fechaVigencia", dataReg?.fechaVigencia+'T00:00:00.000');
      setDeshabilitaRegistroVigencia(true);

      const {data } = await trackPromise(DnerhsApi.get(`/profesional/cedula/${target.value}`));
      if (data) {
        setProfesionalId(data.id);
        setFechaCreacion(data.fechaCreacion);
        setUsuarioCreacion(data.idUsuarioCreacion);

        setValue("nombre", data.nombres);
        setValue("apellido", data.apellidos);
        setValue("email", data.email);
        setValue("numeroRegistroProfesional", data.numeroRegistroProfesionalVigente);
        setIsUpdateCreate(true);
        setProfesional(data);
      }else{
        handleFindDatosPersonales(target.value);
      }
      setIsNotReg(false);

    }else{
      setValue("numeroRegistroProfesional", "");
      setValue("fechaVigencia", "");

      setDeshabilitaRegistroVigencia(false);

      let message = "No se encontró el registro profesional, cargue sus datos manualmente ";
      Alert.show({
        message,
        type: "warning"
      })
      //setIsNotReg(true);
      setIsNotReg(false);
    }
  
  };
  const handleFindDatosPersonales = async (event) => {

    const { data } = await trackPromise(findByNumeroCedula(event));
    if (data) {
      setValue("nombre", data.nombres);
      setValue("apellido", data.apellidos);
    }
  };


  const showServerError = (error) => {
    let message = "Ocurrió un error inesperado, por favor vuelva a reintentar";
    if (error.response) {
      message = ResponseUtils.getMessageError(error.response);
    }

    Alert.show({
      message,
      type: "error"
    })
  }

  const showMessageError = (message) => {
    Alert.show({
      message,
      type: "error"
    })
  }
  const onSubmit2 = async (data) => {
    //setHorarios([...horarios, data]);
    //reset2();
    if(timeDesde==="00:00" && timeHasta==="00:00" ){
      Alert.show({
        message : "Verifique el  horario de practica",
        type : "warning"
      })
    }else{
      let date = new Date(getValues2("periodoDesde"));
      let output1 =date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' +  String(date.getDate()).padStart(2, '0') ;
      date = new Date(getValues2("periodoHasta"));
      let output2 =date.getFullYear()  + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0')  ;
      if(output1==="1969-12-31" || output2==="1969-12-31" ){
        Alert.show({
          message : "Verifique el  periodo de practica",
          type : "warning"
        })
      }else{
       
        let url = "/profesionales-horarios";
        const payload = {
          dia: data.dia,
          profesional:{id: profesionalId},
          horarioDesde: timeDesde + ':00',
          horarioHasta: timeHasta     + ':00', 
          periodoDesde:output1,
          periodoHasta: output2,
          profesion: {id: estabecimientoProfesion},
          nombreServicio: {id: nombreServicio}
        };
        
        try {
          let message = "";         
            let result= await DnerhsApi.post(url, {
              ...payload,
            });
            let resultado=  {
              id:result.data.id,
            // establecimiento: establecimientoDatoId,
              dia: result.data.dia,
              horarioDesde: result.data.horarioDesde,
              horarioHasta: result.data.horarioHasta,
              periodoDesde: result.data.periodoDesde,
              periodoHasta: result.data.periodoHasta,
              profesion:  result.data.profesion,
          nombreServicio:  result.data.nombreServicio
            };
            const { data: profHorarioResponseData } = await DnerhsApi.get(`/profesionales-horarios/${profesionalId}/profesional`);
        setHorarios(profHorarioResponseData);
           // setHorarios([...horarios, resultado]);
          setTimeDesde("00:00");
          setTimeHasta("00:00");
          setValues2("dia", "");

          // reset2();
            message = "Datos guardados exitosamente.";
          Alert.show({
            message,
            type: "success"
          })
          
        
        } catch (error) {
          console.log(error);
          if (error.response) {
            Alert.showServerError(error);
          } else {
            Alert.showServerError(error);
          }
        }
      }
    }
  };
  return (
    <div>
      <Grid item xs={12}>
        <Typography align="center" variant="h5" color="primary">
          Agregar Profesional
        </Typography>
      </Grid>
      <div>
        <FormProvider {...methods}>
          <form>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="flex-start"
            >
              <Grid item xs={6} className={classes.form}>
                <Grid item xs={12} className={classes.field}>
                  <FormInput
                    type="number"
                    name="cedulaIdentidad"
                    label="Cédula de Identidad"
                    onBlur={handleFindDatosTutor}
                    errorobj={errors} required
                    disabled={isReadOnly}
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                    <FormInput
                    name="nombre"
                    label="Nombres"
                    errorobj={errors} required
                    disabled={deshabilitaRegistroVigencia}
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormInput
                    name="apellido"
                    label="Apellidos"
                    errorobj={errors} required
                   disabled={deshabilitaRegistroVigencia}
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormInput name="email" label="Email" disabled={isReadOnly}  errorobj={errors} required />
                </Grid>
                
              </Grid>
              <Grid item xs={6} className={classes.form}>
               
              <Grid item xs={12} className={classes.field}>
                  <FormInput
                  value={profesion}
                    name="profesion"
                    label="Profesión"
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormInput
                    name="numeroRegistroProfesional"
                    label="Nro. Registro Profesional"
                    disabled={deshabilitaRegistroVigencia}
                    errorobj={errors} required
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormDatePicker name="fechaVigencia" label="Fecha vigencia" 
                                        disabled={deshabilitaRegistroVigencia}
                                         required
                />
                </Grid>  
                <Grid item xs={12} className={classes.field}>

                  <FormCheckBox
                      checked={esTutor}

                      label="Es Tutor"
                      name="tutor"
                      inputProps={{
                        "aria-label": "primary checkbox",
                      }}
                      defaultValue={false}
                      defaultChecked={false}
                  
                      disabled={isReadOnly}
                  />            
                </Grid>
                <Grid item xs={12} className={classes.field}>

                  <FormCheckBox 
                      checked={esExterno}
                      /*onChange={(event) =>
                        handleChangeConfirmacion(event, row)
                      }*/
                      
                      label="Externo"
                      name="externo"
                      inputProps={{
                        "aria-label": "primary checkbox",
                      }}
                      defaultValue={false}
                      defaultChecked={false} 
                      disabled={isReadOnly}
                    />
                </Grid>
              </Grid>
            </Grid>
            
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              
              
              {!isAdmin &&
                (!isUpdate ? (
                  <Grid item className={classes.field}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit(onSubmit)}
                      disabled={ isReadOnly}
                    >
                      Guardar
                    </Button>
                  </Grid>
                ) : (
                  <Grid item className={classes.field}>
                    <Button
                      variant="contained"
                      color="primary"
                       onClick={handleSubmit(onSubmit)}
                      disabled={isReadOnly}
                    >
                      Editar
                    </Button>
                  </Grid>
                ))
              }
            </Grid>
            {(!isAdmin) && (
                <Grid item xs={12}>
                  <Box paddingTop={3}>
                    <FormProvider {...methods2}>
                      <form>
                        <Grid container direction="row">
                          <Grid item xs={4}>
                            <Grid item xs={12} className={classes.field}>
                              <Typography
                                align="left"
                                variant="h6"
                                color="primary"
                              >
                                Nuevo horario laboral
                              </Typography>
                            </Grid>
                            
                            <Grid item xs={12} className={classes.field}>
                              <FormSelect
                                name="dia"
                                label="Día"
                                disabled={!isCargarHorario}
                                options={DIAS_SEMANA2}
                                required
                              />
                            </Grid>
                            <Grid item xs={12} className={classes.field}>
                              <FormInput
                                name="horarioDesde"
                                type="time"
                               
                                label="Horario desde"
                                disabled={!isCargarHorario}
                                required
                                defaultTime="00:00"
                                value={timeDesde}
                                onChange={changeTimeDesde}

                                // errorobj={errors}
                              />
                            </Grid>
                            <Grid item xs={12} className={classes.field}>
                              <FormInput
                                name="horarioHasta"
                                type="time"
                                label="Horario desde"
                                disabled={!isCargarHorario}
                                required
                                defaultValue="00:00"
                                value={timeHasta}
                                onChange={changeTimeHasta}
                                // errorobj={errors}
                              />
                            </Grid>
                            <Grid item xs={12} className={classes.field} >
                              <FormDatePicker name="periodoDesde" label="Periodo desde"  disabled={!isCargarHorario}/>                          
                            </Grid>
                            <Grid item xs={12} className={classes.field} >
                              <FormDatePicker name="periodoHasta" label="Periodo hasta"  disabled={!isCargarHorario} />                          
                            </Grid>
                            <Grid item xs={12}>
                              <Grid
                                container
                                direction="row"
                                justifyContent="flex-end"
                                alignContent="flex-end"
                              >
                                {
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={handleSubmit2(onSubmit2)}
                                    className={classes.field}
                                    disabled={!isCargarHorario ||  isReadOnly}
                                  >
                                    Agregar
                                  </Button>
                                }
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={8}>
                            <Grid item xs={12} className={classes.field}>
                              <Typography
                                align="center"
                                variant="h6"
                                color="primary"
                              >
                                Horario Laboral
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <TableContainer component={Paper}>
                                <Table aria-label="Datos estadisticos">
                                  <TableHead>
                                    <TableRow>
                                    <TableCell align="center">Nombre Servicio</TableCell>
                                                                        <TableCell align="center">Profesion</TableCell>

                                    <TableCell align="center">Día</TableCell>

                                      <TableCell align="right">
                                        Horario Desde
                                      </TableCell>
                                      <TableCell align="right">
                                        Horario Hasta
                                      </TableCell>
                                      <TableCell align="right">
                                        Periodo Desde
                                      </TableCell>
                                      <TableCell align="right">
                                      Periodo Hasta
                                      </TableCell>
                                      <TableCell align="center">
                                        Acción
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {horarios
                                      .sort((a, b) =>
                                        a.anio > b.anio ? -1 : 1
                                      )
                                      .map((row, index) => (
                                        <TableRow key={index}>
                                        
                                        <TableCell align="right">
                                            {row.nombreServicio.nombre}
                                          </TableCell>
                                          <TableCell align="right">
                                            {row.profesion.descripcion}
                                          </TableCell>
                                          <TableCell align="center">
                                            {
                                              DIAS_SEMANA2.find(
                                                (item) => item.id == row.dia
                                              )?.label
                                            }
                                          </TableCell>
                                          <TableCell align="right">
                                            {row.horarioDesde}
                                          </TableCell>
                                          <TableCell align="right">
                                            {row.horarioHasta}
                                          </TableCell>
                                          <TableCell align="right">
                                            {row.periodoDesde}
                                          </TableCell>
                                          <TableCell align="right">
                                            {row.periodoHasta}
                                          </TableCell>
                                          <TableCell align="center">
                                            <Tooltip
                                              title="Eliminar"
                                              aria-label="eliminar"
                                            >
                                              <IconButton
                                                size="small"
                                                aria-label="eliminar"
                                                color="secondary"
                                                onClick={() =>
                                                  handleOpenDialog(row.id, index)
                                                }
                                                disabled={isReadOnly}

                                              >
                                                <DeleteIcon />
                                              </IconButton>
                                            </Tooltip>
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Grid>
                          </Grid>
                        </Grid>
                      </form>
                    </FormProvider>
                  </Box>
                </Grid>
              )}
          </form>
        </FormProvider>
        <DeleteDialog
            open={openDialog}
            onClose={handleCloseDialog}
            onAccept={deleteOne}
            aria-labelledby="form-dialog-title"
          />
      </div>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Grid item className={classes.field}>
          <Button
            variant="contained"
            color="default"
            onClick={() => history.goBack()}
          >
            Atrás
          </Button>
        </Grid>
        
        
      </Grid>
    </div>
  );
};

export default Form;